<template>
  <h1>Oops!</h1>
  <p>The page you're looking for is not here.</p>
  <router-link to="/">Back to the home page</router-link>
</template>
